export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">随时随地吃瓜</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">手机在手，吃瓜不愁</p>

        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full max-w-[320px]">
            <div className="relative w-full aspect-[9/16] rounded-2xl overflow-hidden bg-gradient-to-b from-primary-500/20 to-accent-500/10 flex items-center justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20news%20and%20entertainment%20app%20interface%20with%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20mobile%20UI%20with%20article%20cards%20and%20icons%2C%20soft%20lighting%2C%20minimal%20product%20photography%20style%2C%20white%20background&width=640&height=1136&seq=app-mockup-2026&orientation=portrait"
                alt="51吃瓜网手机端入口展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1 space-y-6">
            <div className="space-y-4">
              {[
                { icon: 'ri-smartphone-line', title: '手机浏览器直达', desc: '无需下载安装，手机浏览器输入51吃瓜网最新网址，即刻畅享全部功能，界面自适应移动端，操作流畅不卡顿。' },
                { icon: 'ri-shield-check-line', title: '安全正版入口', desc: '所有移动端入口均经官方认证，杜绝钓鱼网站与恶意广告，保障你的设备安全与浏览隐私。' },
                { icon: 'ri-notification-3-line', title: '热点推送提醒', desc: '关注51吃瓜网官方公众号或添加桌面快捷方式，重大娱乐事件第一时间推送通知，再也不会错过任何热门吃瓜。' },
                { icon: 'ri-link', title: '多入口自动切换', desc: '当单一入口拥堵或失效时，系统自动切换至备用入口，确保你始终畅连51吃瓜网，不受网络波动影响。' },
              ].map((item) => (
                <div key={item.title} className="flex gap-4">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-lg text-primary-500`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#contact');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              获取最新入口
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}